export default "__VITE_ASSET__DNnwQqa___"